import moment from 'moment';
import React from 'react';
import { useIntl } from 'react-intl';

import { FieldInput } from '../../../ui';
import { SettingsBlock } from '../SettingsBlock/SettingsBlock';
import { UserFieldWrapper } from '../style';
import { UserState } from '../types';

type Props = {
  state: UserState;
};

const AdditionalInfo = ({ state }: Props): JSX.Element | null => {
  const intl = useIntl();

  const { country, birthday } = state.user;

  if (country || birthday) {
    return (
      <SettingsBlock label={intl.messages['users.settings.additional-info.label']} withBorder>
        <UserFieldWrapper>
          <FieldInput
            readOnly
            label={intl.messages['users.settings.additional-info.country']}
            name="country"
            value={intl.formatMessage({ id: `form.select.country-name.${country}` })}
          />
        </UserFieldWrapper>
        <FieldInput
          readOnly
          label={intl.messages['users.settings.additional-info.age']}
          name="age"
          value={moment().diff(moment(birthday, 'DD MMM YYYY'), 'years')}
        />
      </SettingsBlock>
    );
  }

  return null;
};

export default AdditionalInfo;
